import React, { memo, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fade, Menu, Modal } from "@mui/material";

import styles from "../../common/ProfileCard/ProfileCard.module.css";
import profileImg from "../../../assets/images/png/profile-pic.jpg";
import profileIcon from "../../../assets/images/svg/profile@.svg";
import settingImg from "../../../assets/images/svg/settings@.svg";
import logoutImg from "../../../assets/images/svg/logout@.svg";

import PopupFrame from "../../Popups/PopupFrame/PopupFrame";
import DButton from "../../Dashboard/DashboardButtons/Dbutton";
import DButtonOutlined from "../../Dashboard/DashboardButtons/dButtonOutlined";

import { logOut } from "../../../features/AuthSlice";
import { setLoginData } from "../../../features/LoginDataSlice";
import { setSideBarToggle } from "../../../features/SideBarToggleSlice";

const UnregisteredVendorProfileCard = ({ profilePath }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const adminData = useSelector((state) => state.adminData.value);
  const loginData = useSelector((state) => state.loginData.value);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [openSettings, setOpenSettings] = useState(false);

  const displayName = useMemo(() => {
    return (
      loginData?.userName ||
      loginData?.name ||
      loginData?.username ||
      loginData?.user?.userName ||
      loginData?.user?.name ||
      loginData?.user?.username ||
      adminData?.first_name ||
      loginData?.user?.first_name ||
      loginData?.user?.email ||
      "No username"
    );
  }, [loginData, adminData]);

  const displayEmail = useMemo(() => {
    return loginData?.email || loginData?.user?.email || "";
  }, [loginData]);

  const handleLogout = () => {
    dispatch(setSideBarToggle(false));
    dispatch(setLoginData([]));
    dispatch(logOut());
    navigate("/login");
  };

  const settingsHeading = [{ heading: "Settings", subHeading: "Coming soon" }];
  const settingsInputs = [
    <div key="placeholder" style={{ padding: 8, fontFamily: "gilroyMedium" }}>
      You can enable change password/settings after backend integration.
    </div>,
  ];
  const settingsActions = [
    <DButtonOutlined
      key="close"
      label={"Close"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={() => setOpenSettings(false)}
    />,
    <DButton
      key="ok"
      label={"Okay"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={() => setOpenSettings(false)}
    />,
  ];

  return (
    <>
      <div className={styles.profileWrapper}>
        <div
          className={styles.profile}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <div className={styles.profile_image}>
            <img
              src={
                adminData?.profile_image?.includes("False") ||
                adminData?.profile_image === null ||
                !adminData?.profile_image
                  ? profileImg
                  : adminData?.profile_image
              }
              alt="Profile"
            />
          </div>

          <div className={styles.profile_text}>
            <span className={styles.profile_name}>
              {displayName}
            </span>
            <p className={styles.profile_role}>Unregistered Supplier</p>
          </div>
        </div>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          elevation={0}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: window.innerWidth < 768 ? "left" : "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{
            transform:
              window.innerWidth < 768
                ? "translate(50px,10px)"
                : "translate(20px,10px)",
            ".MuiMenu-list": { paddingTop: 0, paddingBottom: 0 },
            ".MuiMenu-paper": { boxShadow: "0px 6px 24px #00000017" },
          }}
        >
          <div className={styles.dropdown_menu}>
            <div className={styles.profilecardSm}>
              <div className={styles.profile_text}>
                <em className={styles.profile_name}>
                  {displayName}
                </em>
                {displayEmail ? (
                  <p
                    className={styles.profile_role}
                    style={{ fontFamily: "gilroyMedium" }}
                    title={displayEmail}
                  >
                    {displayEmail}
                  </p>
                ) : null}
                <p className={styles.profile_role}>Unregistered Supplier</p>
              </div>
            </div>

            <span
              onClick={() => {
                setAnchorEl(null);
                navigate(profilePath);
              }}
            >
              <img src={profileIcon} alt="" /> <p>My Profile</p>
            </span>
            <span
              onClick={() => {
                setAnchorEl(null);
                setOpenSettings(true);
              }}
            >
              <img src={settingImg} alt="" /> <p>Settings</p>
            </span>
            <div className={styles.line}></div>
            <span
              onClick={() => {
                setAnchorEl(null);
                handleLogout();
              }}
            >
              <img src={logoutImg} alt="" /> <p>Logout</p>
            </span>
          </div>
        </Menu>
      </div>

      <Modal
        open={openSettings}
        closeAfterTransition
        sx={{ overflow: "auto" }}
      >
        <Fade in={openSettings}>
          <div className={styles.flex} style={{ height: "100vh" }}>
            <PopupFrame
              customClass={styles.settingsPopup}
              inputChildren={settingsInputs}
              poupHeading={settingsHeading}
              actionButtons={settingsActions}
              closePopup={() => setOpenSettings(false)}
            />
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default memo(UnregisteredVendorProfileCard);
